import DialogButton from './dialog-button';

export default {
  init: function (selector) {
    const dialogButton = document.querySelector(selector);
    if (dialogButton) {
      const dialogButtonInit = new DialogButton(dialogButton);
      dialogButtonInit.init();
    }
  }
};
